// NGRX
import { createFeatureSelector, createSelector } from '@ngrx/store';
// Lodash
import { each } from 'lodash';
// CRUD
import { QueryResultsModel, HttpExtenstionsModel } from '../../_base/crud';
// State
import { ProductState } from '../_reducers/product.reducers';
import { Product, ProductType, ProductVariety } from '../_models/product.model';

export const selectProductsState = createFeatureSelector<ProductState>('products');

export const selectProductById = (productId: number) => createSelector(
    selectProductsState,
    productsState => productsState.entities[productId]
);

export const selectProductsPageLoading = createSelector(
    selectProductsState,
    productsState => productsState.listLoading
);

// export const selectProductsActionLoading = createSelector(
//     selectProductsState,
//     customersState => customersState.actionsloading
// );

export const selectProductsPageLastQuery = createSelector(
    selectProductsState,
    productsState => productsState.lastQuery
);

export const selectLastCreatedProductId = createSelector(
    selectProductsState,
    productsState => productsState.lastCreatedProductId
);

export const selectLastUpdatedProductId = createSelector(
    selectProductsState,
    productsState => productsState.lastUpdatedProductId
);

export const selectLastDeletedProductId = createSelector(
    selectProductsState,
    productsState => productsState.lastDeletedProductId
);

export const selectProductsInitWaitingMessage = createSelector(
    selectProductsState,
    productsState => productsState.showInitWaitingMessage
);

export const selectProductsInStore = createSelector(
    selectProductsState,
    productsState => {
        const items: Product[] = [];
        each(productsState.entities, element => {
            items.push(element);
        });
        const httpExtension = new HttpExtenstionsModel();
        const result: Product[] = httpExtension.sortArray(items, productsState.lastQuery.sortField, productsState.lastQuery.sortOrder);
        return new QueryResultsModel(result, productsState.totalCount, '');
    }
);

export const selectHasProductsInStore = createSelector(
    selectProductsInStore,
    queryResult => {
        if (!queryResult.totalCount) {
            return false;
        }

        return true;
    }
);

//PRODUCT TYPES
export const selectProductTypesState = state => state.productTypes;

export const productTypesLoaded = createSelector(
    selectProductTypesState,
    productTypesState => productTypesState.productTypesLoaded
)

export const selectProductTypes = createSelector(
    selectProductTypesState,
    productTypesState => {
        const items: ProductType[] = [];
        each(productTypesState.productTypes, element => {
            items.push(element);
        });
        return items;
    }
)

//PRODUCT VARIETIES
export const selectProductVarietiesState = state => state.productVarieties;

export const productVarietiesLoaded = createSelector(
    selectProductVarietiesState,
    productVarietiesState => productVarietiesState.productVarietiesLoaded
)

export const selectProductVarieties = createSelector(
    selectProductVarietiesState,
    productVarietiesState => {
        const items: ProductVariety[] = [];
        each(productVarietiesState.productVarieties, element => {
            items.push(element);
        });
        return items;
    }
)